import React from 'react';
import {connect} from 'react-redux';
import {Menu, Layout, Icon} from 'antd';
import {Link} from 'react-router-dom';
import {fetchSettings} from '../../actions';
const {Sider} = Layout;

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false
        }
    }

    componentDidMount() {
        const {landlord: {id}, fetchSettings} = this.props;
        return fetchSettings(id)
    }

    render() {
        const {auth: {isAuthenticated}, selectedMenu, settings: {data}} = this.props;
        const disabled = () => !data.filter(i => i.config).length;

        if (!isAuthenticated) {
            return <div />;
        }
        const menuItems = [
            {key: '/provider/profile', label: 'My Details', icon: 'user'},
            {key: '/provider/branches', label: 'Branches', icon: 'shop'},
            {key: '/provider/admins', label: 'Admin Users', icon: 'team'},
            {key: '/provider/dlo/settings', label: 'DLO', icon: 'book', children: [
                {key: '/provider/dlo/engineers', label: 'Gas Engineers', icon: '', disabled: disabled()},
                {key: '/provider/dlo/non-engineers', label: 'Non Gas Engineers', icon: '', disabled: disabled()}
            ]},
            {key: '/provider/settings', label: 'Settings', icon: 'setting', children: [
                {key: '/provider/settings/dlo', label: 'DLO', icon: ''},
                {key: '/provider/settings/contractors', label: 'Contractors', icon: ''}
            ]},
            {key: '/provider/contractors', label: 'Contractors', icon: 'contacts'},
            {key: '/provider/properties', label: 'Properties', icon: 'home', children: [
                {key: '/provider/properties', label: 'Active', icon: ''},
                {key: '/provider/properties/retired', label: 'Retired', icon: ''}
            ]}
        ];

        const current = menuItems.find(i => i.key === selectedMenu);
        const selected = current && [current.key];
        const onCollapse = collapsed => {
            this.setState({
                collapsed
            })
        };
        const renderMenuItem = i => (
            <Menu.Item key={i.key} disabled={i.disabled || false} style={{overflow: 'hidden', whiteSpace: 'normal'}}>
                <Link to={i.key} style={{display: 'inline-block', width: '100%'}}>
                    {i.icon ? <span><Icon type={i.icon} /> {i.label}</span> : <span>{i.label}</span>}
                </Link>
            </Menu.Item>
        );
        const renderSubMenu = i => (
            <Menu.SubMenu title={<span><Icon type={i.icon} /><span>{i.label}</span></span>} key={i.key}>
                {i.children.map(renderMenuItem)}
            </Menu.SubMenu>
        );
        const renderItem = i => {
            if (i.children) {
                return renderSubMenu(i);
            }
            return renderMenuItem(i)
        };
        return (
            <Sider
                id="sider"
                width={250}
                style={{ background: '#fff' }}
                collapsible
                collapsed={this.state.collapsed}
                onCollapse={onCollapse}
                breakpoint="sm"
            >
                <Menu
                    defaultSelectedKeys={selected}
                    style={{ height: '100%', paddingTop: '24px' }}
                    mode='inline'
                >
                    {menuItems.map(renderItem)}
                </Menu>
            </Sider>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        settings: state.landlord.dlo.settings,
        landlord: state.me.application
    }
};
export default connect(mapStateToProps, {fetchSettings})(Sidebar);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/Sidebar.js